import React from "react";

const HeroLoad = ({ title, subTitle, color }) => {
  return (
    <div
      className={`w-full h-[450px] md:h-[790px] flex justify-center items-center`}
    >
      <div className="relative max-w-xs md:max-w-[583px] w-full">
        <h1
          className="block  text-4xl md:text-7xl italic text-center leading-[45px] md:leading-[86px] mt-6"
          style={{ color: `${color}` }}
        >
          {title}
        </h1>
        <p
          className="block md:hidden text-base font-dinnext leading-[18px] mt-5 font-light text-center relative z-10"
          style={{ color: `${color}` }}
        >
          {subTitle}
        </p>
      </div>
    </div>
  );
};

export default HeroLoad;
